export default __webpack_public_path__ + "static/media/about1-mobi.34b2bc2a.webp";